var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-black text-center flex flex-col justify-center",attrs:{"id":"root"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(this.$root.print.title))]),_vm._v(" "),_c('div',{staticClass:"coordinate"},[_vm._v(_vm._s(this.$root.print.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }